
























import Vue from "vue";

import LayoutPrivate from "@tt-app/layouts/LayoutPrivate.vue";
import LayoutPublic from "@tt-app/layouts/LayoutPublic.vue";
import AuthCard from "@tt-app/components/user/auth/AuthCard.vue";
import AuthContainer from "@tt-app/components/user/auth/AuthContainer.vue";

import { isUserAuthenticated } from "@tt-app/utils";

interface Computed {
  isUserAuthenticated: boolean;
}

export default Vue.extend<{}, {}, Computed, {}>({
  components: { AuthCard, AuthContainer, LayoutPrivate, LayoutPublic },

  computed: {
    isUserAuthenticated() {
      return isUserAuthenticated();
    }
  }
});
